<template>
  <div class="listCardPushMongolStatus" v-if="isAdminUser">
    <el-button v-if="!isMongolPushed" class="pushbtn" type="primary" :loading="pushLoading" @click.stop="pushMongol(Detail)">推送</el-button>
  </div>
</template>

<script>
export default {
  name: "ListCard",
  props: {
    Detail: {
      type: Object,
      default() {
        return ()=> {};
      },
    },
  },
  data() {
    return {
      isMongolPushed: true,
      pushLoading: false,
    };
  },
  computed:{
    isAdminUser(){
      if (this.$store.state.userInfo && this.$store.state.userInfo.userId == "97771494"){
        return true
      }
      else {
        return false
      }
    }
  },
  mounted() {
    this.isMongolianPushCheck(this.Detail)
  },
  methods: {
    //点击分享按钮
    pushMongol(item){
      if (this.pushLoading){
        return
      }
      let text = '确定要推送《'+item.name+'》到蒙文歌单列表吗?'
      if (this.isMongolPushed){
        text = '确定要更新歌单《'+item.name+'》吗?'
      }
      this.$confirm(text, '提示', {
        type: 'warning'
      }).then(() => {
        this.syncToMongolian(item);
      }).catch(() => { });
    },
    async isMongolianPushCheck(item) {
      // 请求
      await this.$http({
        url: '/music/playlist/check/'+item.id,
        method: 'get'
      }).then(( res ) => {
        if (res.data && res.data.data){
          this.isMongolPushed = true
        }
        else{
          this.isMongolPushed = false
        }
      }).catch(({ e }) => {
        console.log(e)
      })
    },
    syncToMongolian(item){
      this.pushLoading = true
      this.$http({
        url: '/music/playlist/push/'+item.id,
        method: 'post'
      }).then(({ res }) => {
        this.isMongolPushed = true
        this.pushLoading = false
      }).catch(({ e }) => {
        this.pushLoading = false
      })
    },
  },
  watch: {
    //   数据更新后，
    Detail(newVal) {

      this.isMongolianPushCheck(newVal)
    },
  },
};
</script>

<style lang="less" scoped>
.listCardPushMongolStatus{
  position: absolute;
  right: 0;
  top: 0;
  .pushbtn{
    padding: 5px 10px;
    font-size: 10px;
    opacity: 0.8;
    &:hover{
      opacity: 1;
    }
  }
}
</style>
